.u8njfm0::placeholder {
  color: var(--placeholder-color);
}